<template lang="pug">
b-container.dsg-page(fluid)
    .dsg-page-header
        div
            h1.dsg-page-title
                Icon(icon="mdi:file-export-outline")
                | Client Exports
            p.dsg-page-subtitle Download client data as Excel files

    b-row
        //- b-col.col-12.col-md-6.col-lg-3.mb-4
        //-     .dsg-card.h-100
        //-         .dsg-card-pad.dsg-export-tile
        //-             Icon.dsg-export-icon(icon="mdi:account-group-outline" width="34")
        //-             .dsg-export-name All Clients
        //-             .dsg-export-desc All active and discharged clients, with status and programme
        //-             b-button.btn-dsg.dsg-export-btn(
        //-                 :disabled="isExporting.allClients || isFetchingAdminDashboardData"
        //-                 @click="exportAllClients"
        //-             )
        //-                 b-spinner.mr-1(small v-if="isExporting.allClients")
        //-                 Icon.mr-1(v-else icon="mdi:microsoft-excel")
        //-                 | Export
        b-col.col-12.col-md-6.col-lg-3.mb-4
            .dsg-card.h-100
                .dsg-card-pad.dsg-export-tile
                    Icon.dsg-export-icon(icon="mdi:clipboard-text-outline" width="34")
                    .dsg-export-name Active Clients — MOCA
                    .dsg-export-desc Client list with latest MOCA score and education level
                    b-button.btn-dsg.dsg-export-btn(
                        :disabled="isExporting.assessment || isFetchingAdminDashboardData"
                        @click="exportActiveClientsAssessment"
                    )
                        b-spinner.mr-1(small v-if="isExporting.assessment")
                        Icon.mr-1(v-else icon="mdi:microsoft-excel")
                        | Export
        b-col.col-12.col-md-6.col-lg-3.mb-4
            .dsg-card.h-100
                .dsg-card-pad.dsg-export-tile
                    Icon.dsg-export-icon(icon="ph:calendar-check" width="34")
                    .dsg-export-name Active Clients — Sessions
                    .dsg-export-desc Active clients and enrolled scheduler 
                    b-button.btn-dsg.dsg-export-btn(
                        :disabled="isExporting.sessions || isFetchingAdminDashboardData"
                        @click="exportActiveClientsSessions"
                    )
                        b-spinner.mr-1(small v-if="isExporting.sessions")
                        Icon.mr-1(v-else icon="mdi:microsoft-excel")
                        | Export
        b-col.col-12.col-md-6.col-lg-3.mb-4
            .dsg-card.h-100
                .dsg-card-pad.dsg-export-tile
                    Icon.dsg-export-icon(icon="mdi:view-list-outline" width="34")
                    .dsg-export-name By Scheduler
                    .dsg-export-desc One sheet per active scheduler, listing the active clients
                    b-button.btn-dsg.dsg-export-btn(
                        :disabled="isExporting.byScheduler || isFetchingAdminDashboardData"
                        @click="exportByScheduler"
                    )
                        b-spinner.mr-1(small v-if="isExporting.byScheduler")
                        Icon.mr-1(v-else icon="mdi:microsoft-excel")
                        | Export
</template>

<script>
import dayjs from 'dayjs';
import XLSX from 'xlsx-js-style';
import { mapState } from 'vuex';
import { Icon } from '@iconify/vue2';
import { ADMIN_DASHBOARD_NAMESPACE } from '../../store/Modules/AdminDashboard/types-admin-dashboard';

export default {
    components: {
        Icon,
    },
    data() {
        return {
            isExporting: {
                allClients: false,
                assessment: false,
                sessions: false,
                byScheduler: false,
            },
        }
    },
    computed: {
        ...mapState({
            listClient: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listClient),
            listMasterScehdule: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listMasterScehdule),
            isFetchingAdminDashboardData: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.isFetchingAdminDashboardData),
        }),
    },
    methods: {
        normalizeId(id){
            return String(id || '').toLowerCase().replace(/[{}]/g, '');
        },
        sortClientByName(list){
            return [...list].sort((a, b) =>
                (a.crb5c_no || '').localeCompare(b.crb5c_no || '', undefined, { sensitivity: 'base' })
            );
        },
        isCipSchedule(schedule){
            return schedule.crb5c_iscipsession === true;
        },
        getSessionNames(listSchedule){
            return [...new Set(
                listSchedule
                    .map(schedule => String(schedule.crb5c_session_id || '').trim())
                    .filter(Boolean)
            )].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
        },
        // map: clientId -> [master schedule, ...] the client is currently enrolled in
        async fetchClientSessionMap(){
            const { data } = await this.$store.state.api.get('/session_client_relationship');
            const relationships = data?.sessions ?? [];

            const scheduleById = new Map(
                this.listMasterScehdule
                    // keep only schedules still active in the master scheduler
                    .filter(schedule => schedule.crb5c_isactive !== false)
                    .map(schedule => [this.normalizeId(schedule.crb5c_fow_session_scheduleid), schedule])
            );

            const clientSessionMap = new Map();
            for(const relationship of relationships){
                const clientId = this.normalizeId(relationship.crb5c_fow_customerid);
                const schedule = scheduleById.get(this.normalizeId(relationship.crb5c_fow_session_scheduleid));
                if(!clientId || !schedule){
                    continue;
                }
                if(!clientSessionMap.has(clientId)){
                    clientSessionMap.set(clientId, []);
                }
                clientSessionMap.get(clientId).push(schedule);
            }
            return clientSessionMap;
        },
        // latest assessment per client (list from API is already ordered createdon desc)
        async fetchLatestAssessmentMap(){
            const { data } = await this.$store.state.api.get('/assessment');
            const assessments = data?.assessment ?? [];

            const byClientId = new Map();
            const byClientName = new Map();
            for(const assessment of assessments){
                const clientId = this.normalizeId(assessment.crb5c_clientid);
                if(clientId && !byClientId.has(clientId)){
                    byClientId.set(clientId, assessment);
                }
                const clientName = String(assessment.crb5c_clientname || '').trim().toLowerCase();
                if(clientName && !byClientName.has(clientName)){
                    byClientName.set(clientName, assessment);
                }
            }
            return { byClientId, byClientName };
        },
        buildStyledWorksheet(rows, generatedOn, title){
            // row 1: generated timestamp, row 2: optional title, row 3 onwards: the data table
            const worksheet = XLSX.utils.aoa_to_sheet([[`Generated on ${generatedOn}`]]);
            worksheet['A1'].s = {
                font: { italic: true, sz: 10, color: { rgb: '6C7280' } },
            };
            if(title){
                XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: 'A2' });
                worksheet['A2'].s = {
                    font: { bold: true, sz: 12, color: { rgb: '51276B' } },
                };
            }
            XLSX.utils.sheet_add_json(worksheet, rows, { origin: 'A3' });

            const listHeader = Object.keys(rows[0]);

            // column widths based on the longest value per column
            worksheet['!cols'] = listHeader.map((header) => ({
                wch: Math.min(
                    60,
                    Math.max(header.length, ...rows.map(row => String(row[header] ?? '').length)) + 2
                ),
            }));

            // header row styling (row 3 -> index 2)
            listHeader.forEach((_, index) => {
                const cellRef = XLSX.utils.encode_cell({ r: 2, c: index });
                if(worksheet[cellRef]){
                    worksheet[cellRef].s = {
                        font: { bold: true, color: { rgb: 'FFFFFF' } },
                        fill: { fgColor: { rgb: '51276B' } },
                        alignment: { horizontal: 'center', vertical: 'center' },
                    };
                }
            });

            return worksheet;
        },
        // sheets: [{ rows, name, title? }] — sheets with no rows are skipped
        exportSheetsToExcel(sheets, fileName){
            const listSheetWithData = sheets.filter(sheet => sheet.rows.length > 0);
            if(listSheetWithData.length === 0){
                this.$bvToast.toast('No data to export', {
                    title: 'Export',
                    variant: 'warning',
                    solid: true,
                });
                return;
            }

            const generatedOn = dayjs().format('DD MMM YYYY, hh:mm A');
            const workbook = XLSX.utils.book_new();
            const usedSheetNames = new Set();
            for(const sheet of listSheetWithData){
                XLSX.utils.book_append_sheet(
                    workbook,
                    this.buildStyledWorksheet(sheet.rows, generatedOn, sheet.title),
                    this.makeSheetName(sheet.name, usedSheetNames)
                );
            }
            XLSX.writeFile(workbook, `${fileName}_${dayjs().format('YYYY-MM-DD')}.xlsx`);
        },
        // sheet names: max 31 chars, no : \\ / ? * [ ] and unique within the workbook
        makeSheetName(rawName, usedSheetNames){
            const cleanName = String(rawName || 'Sheet').replace(/[:\\/?*[\]]/g, ' ').replace(/\s+/g, ' ').trim() || 'Sheet';
            let sheetName = cleanName.slice(0, 31);
            let counter = 2;
            while(usedSheetNames.has(sheetName.toLowerCase())){
                const suffix = ` (${counter})`;
                sheetName = cleanName.slice(0, 31 - suffix.length) + suffix;
                counter++;
            }
            usedSheetNames.add(sheetName.toLowerCase());
            return sheetName;
        },
        exportRowsToExcel(rows, sheetName, fileName){
            this.exportSheetsToExcel([{ rows, name: sheetName }], fileName);
        },
        // 1. all clients (active or discharged)
        exportAllClients(){
            this.isExporting.allClients = true;
            try {
                const rows = this.sortClientByName(
                    (this.listClient || []).filter(client => client.status === 'Active' || client.status === 'Discharge')
                ).map(client => ({
                    'Client Name': client.crb5c_no || 'N/A',
                    'Status': client.status,
                    'Programme': client.programme,
                    'Registered On': client.formattedCreateOn || 'N/A',
                }));

                this.exportRowsToExcel(rows, 'All Clients', 'FOW_All_Clients');

            } catch (error) {
                console.error(error);
                this.$bvToast.toast('Failed to export clients', {
                    title: 'Export',
                    variant: 'danger',
                    solid: true,
                });
            } finally {
                this.isExporting.allClients = false;
            }
        },
        // 2. active clients: name, session day, educational level, latest total MOCA score
        async exportActiveClientsAssessment(){
            this.isExporting.assessment = true;
            try {
                const [clientSessionMap, latestAssessmentMap] = await Promise.all([
                    this.fetchClientSessionMap(),
                    this.fetchLatestAssessmentMap(),
                ]);

                const activeClients = this.sortClientByName(
                    (this.listClient || []).filter(client => client.status === 'Active')
                );

                const rows = activeClients.map((client) => {
                    const clientId = this.normalizeId(client.crb5c_fow_customerid);
                    const listSessionName = this.getSessionNames(clientSessionMap.get(clientId) ?? []);

                    const clientName = String(client.crb5c_no || '').trim().toLowerCase();
                    const assessment = latestAssessmentMap.byClientId.get(clientId)
                        ?? latestAssessmentMap.byClientName.get(clientName);

                    return {
                        'Client Name': client.crb5c_no || 'N/A',
                        'Session': listSessionName.length ? listSessionName.join(', ') : 'N/A',
                        'Educational Level': assessment?.crb5c_educationlevel || 'N/A',
                        'Latest Total MOCA Score': assessment?.crb5c_mocatotalscore ?? 'N/A',
                    };
                });

                this.exportRowsToExcel(rows, 'Active Clients Assessment', 'FOW_Client_Moca (Latest)t');

            } catch (error) {
                console.error(error);
                this.$bvToast.toast('Failed to export assessment data', {
                    title: 'Export',
                    variant: 'danger',
                    solid: true,
                });
            } finally {
                this.isExporting.assessment = false;
            }
        },
        // 3. active clients and the master scheduler sessions they are currently in
        async exportActiveClientsSessions(){
            this.isExporting.sessions = true;
            try {
                const clientSessionMap = await this.fetchClientSessionMap();

                const activeClients = this.sortClientByName(
                    (this.listClient || []).filter(client => client.status === 'Active')
                );

                // sheet 1: one row per client, sessions comma-joined
                const sessionRows = [];
                // sheet 2: clients enrolled in both a FOW (normal) session and a CIP session
                const fowAndCipRows = [];

                for(const client of activeClients){
                    const clientId = this.normalizeId(client.crb5c_fow_customerid);
                    const listSchedule = clientSessionMap.get(clientId) ?? [];
                    const listSessionName = this.getSessionNames(listSchedule);

                    sessionRows.push({
                        'Client Name': client.crb5c_no || 'N/A',
                        'Session': listSessionName.length ? listSessionName.join(', ') : 'Not enrolled',
                    });

                    const listFowSessionName = this.getSessionNames(listSchedule.filter(schedule => !this.isCipSchedule(schedule)));
                    const listCipSessionName = this.getSessionNames(listSchedule.filter(schedule => this.isCipSchedule(schedule)));
                    if(listFowSessionName.length > 0 && listCipSessionName.length > 0){
                        fowAndCipRows.push({
                            'Client Name': client.crb5c_no || 'N/A',
                            'FOW Session': listFowSessionName.join(', '),
                            'CIP Session': listCipSessionName.join(', '),
                        });
                    }
                }

                this.exportSheetsToExcel([
                    { rows: sessionRows, name: 'Active Clients Sessions' },
                    { rows: fowAndCipRows, name: 'FOW & CIP Enrolled clients' },
                ], 'FOW_Clients_Sessions');

            } catch (error) {
                console.error(error);
                this.$bvToast.toast('Failed to export session data', {
                    title: 'Export',
                    variant: 'danger',
                    solid: true,
                });
            } finally {
                this.isExporting.sessions = false;
            }
        },
        // 4. one sheet per active scheduler, listing the active clients enrolled in it
        async exportByScheduler(){
            this.isExporting.byScheduler = true;
            try {
                const clientSessionMap = await this.fetchClientSessionMap();

                const activeClients = this.sortClientByName(
                    (this.listClient || []).filter(client => client.status === 'Active')
                );

                // scheduleId -> [client name, ...] (activeClients is sorted by name, so lists are too)
                const schedulerClientsMap = new Map();
                for(const client of activeClients){
                    const clientId = this.normalizeId(client.crb5c_fow_customerid);
                    for(const schedule of (clientSessionMap.get(clientId) ?? [])){
                        const scheduleId = this.normalizeId(schedule.crb5c_fow_session_scheduleid);
                        if(!schedulerClientsMap.has(scheduleId)){
                            schedulerClientsMap.set(scheduleId, []);
                        }
                        schedulerClientsMap.get(scheduleId).push(client.crb5c_no || 'N/A');
                    }
                }

                const listActiveSchedule = [...this.listMasterScehdule]
                    .filter(schedule => schedule.crb5c_isactive !== false)
                    .sort((a, b) => (a.crb5c_session_id || '').localeCompare(b.crb5c_session_id || '', undefined, { sensitivity: 'base' }));

                const sheets = listActiveSchedule.map((schedule) => {
                    const scheduleName = schedule.crb5c_session_id || 'Unnamed scheduler';
                    const scheduleId = this.normalizeId(schedule.crb5c_fow_session_scheduleid);
                    const listClientName = schedulerClientsMap.get(scheduleId) ?? [];

                    const rows = listClientName.length
                        ? listClientName.map((clientName, index) => ({
                            'No.': index + 1,
                            'Client Name': clientName,
                        }))
                        : [{ 'No.': '', 'Client Name': 'No active clients' }];

                    return {
                        rows,
                        name: scheduleName,
                        title: `${scheduleName} (${listClientName.length} client${listClientName.length === 1 ? '' : 's'})`,
                    };
                });

                this.exportSheetsToExcel(sheets, 'FOW_Clients_By_Scheduler');

            } catch (error) {
                console.error(error);
                this.$bvToast.toast('Failed to export scheduler data', {
                    title: 'Export',
                    variant: 'danger',
                    solid: true,
                });
            } finally {
                this.isExporting.byScheduler = false;
            }
        },
    },
}
</script>

<style scoped>
.dsg-export-tile {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
}
.dsg-export-icon {
    color: var(--dsg-secondary);
}
.dsg-export-name {
    font-weight: 700;
    color: var(--dsg-primary);
    font-size: 1.05rem;
}
.dsg-export-desc {
    color: var(--dsg-muted);
    font-size: 0.9rem;
    flex-grow: 1;
}
.dsg-export-btn {
    display: inline-flex;
    align-items: center;
}
</style>
